export default __webpack_public_path__ + "static/media/Google-logo.2582fe3e.svg";